<template>
  <zj-layout-container>
    <zj-layout-header>
      <div class="listtitle">布控结果</div>
      <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
        <el-form-item></el-form-item>
        <el-form-item label class="right">
          <el-button @click="onBack()">返回</el-button>
          <el-button @click="lookMap">{{showmapbtnText}}</el-button>
        </el-form-item>
      </el-form>
      <div style="margin-top: 2rem;">
        <el-divider></el-divider>
      </div>
    </zj-layout-header>
    <zj-layout-main>
      <div
        v-show="!showMap"
        class="zj-layout-main-content bgcolor scrollable"
        style="overflow: auto"
      >
        <div style="width:100%;height:auto">
          <div v-for="avatar in avatars" :key="avatar" class="avatar">
            <div @dblclick="ondbClickAv(avatar)">
              <el-avatar shape="square" :size="120" fit="fill" :src="avatar.url"></el-avatar>
              <div style="padding: 0.5rem;">{{avatar.cameraName}}</div>
              <div style="padding: 0.5rem;">{{avatar.time}}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="showMap" class="zj-layout-main-content map"></div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
export default {
  name: "FaceResultControl",
  controller: "UI",
  action: "FaceResultControl",
  components: {},
  props: {
    query: { type: Object, default: null },
  },
  data() {
    return {
      controlObj: {},
      avatars: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      showMap: false,
      showmapbtnText: "查看轨迹",
    };
  },
  created: function () {
    if (this.query.controlObj) {
      this.controlObj = this.query.controlObj;
      this.search();
    }
  },
  mounted: function () {},
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    lookMap() {
      if (this.showMap) {
        this.showMap = false;
        this.showmapbtnText = "查看轨迹";
      } else {
        this.showMap = true;
        this.showmapbtnText = "查看列表";
      }
    },
  onBack() {
      this.$router.go(-1); //返回上一层
    },
    search() {
      this.avatars = [
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
      ];
      if (this.avatars.length > 0) {
        this.onDrawMap();
      }
    },
    onDrawMap: function () {
      this.$nextTick(function () {
        // 创建地图，并通过样式让地图填满窗口
        let that = this;
        // eslint-disable-next-line no-undef
        $(function () {
          // 不传入 syscode 和 key ，或者值为空时，
          // zjumap 插件自动从 URL 地址
          // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
          // 中读取 syscode 和 key 的值。
          // eslint-disable-next-line no-undef
          $(".map").zjumap({
            syscode: "ZJMap",
            key: "FaceMap",
            loading: ".global-loading",
            loadingText: ".global-loading-text",
            //地图配置
            mapConfigs: {
              mapStyle: "",
              togglePanelVisiable: false,
              // mapLayers: "DOM",
              // clickToShowLocation: false,
              // reportGeo: true,
              // onGotGeo: function(e) {
              //   e.handled = true;
              //   if (that.marker) {
              //     that.marker.setPosition(
              //       e.map.newPoint(e.point.lng, e.point.lat)
              //     );
              //   } else {
              //     //that.marker = that.addMarker(e.map, e.point);
              //   }
              //   that.dialogVisible2 = true;
              //   that.lat = e.point.lat;
              //   that.lng = e.point.lng;
              // },
              onMapCreated: function (e) {
                console.log("e");
                console.log(e);
                that.mapInstance = e.map;
                // e.map.clearAll();
                that.center = e.map.config.center;
                setTimeout(() => {
                  //  that.addDom();
                }, 1000);
              },
            },
          });
        });
      });
    },
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    formatControlStaus(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      var statusstr = "";
      this.ControlStatusArr.forEach((item) => {
        if (item.value == data) {
          statusstr = item.lable;
        }
      });
      return statusstr;
    },
  },
};
</script>